export const TIMEOUT_ERROR = 'Timeout Error';
export const SERVER_ERROR = 'Server Error';
